import CRUDServiceOperations from "./CRUDServiceOperations";

class EntityMessageLogTypeService extends CRUDServiceOperations {
  getEntitiesUrl = () => {
    return this.urlFactory.entityMessageLogTypes();
  };
}

export default EntityMessageLogTypeService;
